import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { coreProjectLayout } from '@jira/platform__layouts-core-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { classicBusinessProformaIssueFormsDirectRoute } from '@jira/router-routes__proforma-routes/src/classicBusinessProformaIssueFormsDirectRoute.tsx';
import { proformaIssueFormsDirectPageEntryPoint } from './ui/issue-forms-direct/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const classicBusinessProformaIssueFormsDirectRouteEntry: Route = createEntry(
	classicBusinessProformaIssueFormsDirectRoute,
	() => ({
		group: 'classic-business',
		layout: coreProjectLayout,
		// eslint-disable-next-line jira/router/no-project-context-resource
		resources: [...jiraSpaResources(), projectContextResource],

		navigation: {
			menuId: MenuIdProjects,
		},

		entryPoint: () => proformaIssueFormsDirectPageEntryPoint,
		perfMetricKey: 'issue-forms-direct',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
